import { createSlice } from "@reduxjs/toolkit";
const initialState = {};
const filtersSlice = createSlice({
    name: "filters",
    initialState,
    reducers: {
        registerFilter: (state, action) => {
            if (state[action.payload.id]) {
                return;
            }
            state[action.payload.id] = action.payload;
            state[action.payload.id].active = false;
        },
        resetFilter: (state, action) => {
            state[action.payload.id].active = false;
            state[action.payload.id].value = undefined;
        },
        resetAll: (state) => {
            Object.keys(state).forEach((id) => {
                state[id].active = false;
                state[id].value = undefined;
            });
        },
        changeFilterValue: (state, action) => {
            state[action.payload.id].active = true;
            state[action.payload.id].value = action.payload.value;
        },
    },
});
export default filtersSlice;
